
export class Point {

    static readonly NewPointId : string = ''
    static readonly NewPoint : Point = {...new Point(), _id: Point.NewPointId }

    _id : string = ''
    buildingId : string = ''
    public : boolean = false
    civicAddress : string = ''
    floorNum : string = ''
    floorName : string = ''
    quadrant : string = ''
    type : string = ''
    distFromWindow : string = ''
    floorAndDescript : string = ''
    locationDescription : string = ''
    wRef1 : string = ''
    wRef2 : string = ''
    latitude : number = 0
    longitude : number = 0
    geoid : string = ''
    altitudeGeoidMeters : number = 0
    wgs84 : string = ''
    altitudeEllipsoidMeters : number = 0
    windowCnt : string = ''
    floorToCeilingFtIn : string = ''
    clutter : string = ''
    hvac : string = ''
    stage1 : string = ''
    stage2 : string = ''
    stage1a : string = ''
    stage1b2a : string = ''
    stageDl : string = ''
    stageZ : string = ''
    stage1c : string = ''
    stageZa : string = ''
    stage1d : string = ''
    comments : string = ''

    stage1eZb : string = ''
    class : number = 0
    usability : string  = ''
    updatedAt? : number = 0
    deleted?: boolean
    _rev?: string = ''
}


